import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiHome, FiInbox, FiAlertCircle, FiWifiOff, FiMapPin, FiChevronRight } from 'react-icons/fi';
import DashboardLayout from '../../components/layout/DashboardLayout';
import SectionCard from '../../components/ui/SectionCard';
import ListItem from '../../components/ui/ListItem';
import EmptyState from '../../components/ui/EmptyState';
import { getHouses } from '../../services/houseService';
import { formatDateTime } from '../../utils/format';

/**
 * Lista de viviendas ya registradas (`GET /v1/houses`), punto de
 * entrada para "Registrar una visita": el operativo elige la vivienda
 * sobre la que quiere capturar los formularios de visita.
 */
export default function HousesListView() {
  const [houses, setHouses] = useState(null);
  const [error, setError] = useState(null);
  const [offline, setOffline] = useState(false);

  useEffect(() => {
    let active = true;
    setError(null);
    setOffline(!navigator.onLine);
    getHouses()
      .then((data) => {
        if (active) setHouses(data);
      })
      .catch((err) => {
        if (!active) return;
        setHouses([]);
        setError(err.message || 'No se pudieron cargar las viviendas.');
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <DashboardLayout title="Registrar una visita" subtitle="Elige una vivienda">
      {offline && !error && (
        <div className="form-error form-error--muted" role="status">
          <FiWifiOff /> Sin conexión: mostrando viviendas guardadas en este dispositivo.
        </div>
      )}

      {error && (
        <div className="form-error" role="alert">
          <FiAlertCircle /> {error}
        </div>
      )}

      <SectionCard title={houses ? `Viviendas (${houses.length})` : 'Viviendas'}>
        {houses === null && <EmptyState icon={<FiHome />} title="Cargando viviendas…" />}
        {houses !== null && houses.length === 0 && !error && (
          <EmptyState
            icon={<FiInbox />}
            title="Aún no has registrado viviendas"
            description={
              offline
                ? 'No hay viviendas guardadas en este dispositivo todavía.'
                : 'Registra una vivienda para poder capturar visitas sobre ella.'
            }
          />
        )}
        {houses?.map((house) => (
          <ListItem
            key={house.id}
            as={Link}
            to={`/data-entry/houses/${house.id}/visit`}
            icon={<FiMapPin />}
            title={`${house.address.street} ${house.address.exteriorNumber}`.trim()}
            meta={
              `${house.address.neighborhood} · Sección ${house.address.electoralSection}` +
              ` · ${house.pendingSurveys} pendientes` +
              (house.lastVisit ? ` · Última visita: ${formatDateTime(house.lastVisit)}` : '')
            }
            right={<FiChevronRight />}
          />
        ))}
      </SectionCard>
    </DashboardLayout>
  );
}
